
import BackwardItem from "../../../assets/filled/BackwardItem.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function BackwardItemIcon({ className, dataTestid = "BackwardItemIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <BackwardItem data-testid={dataTestid} className={classes} {...rest} />
  );
}
